import {
  ApartmentOutlined,
  ContainerOutlined,
  ExperimentOutlined,
  HomeOutlined,
  LoginOutlined,
  LogoutOutlined,
  QrcodeOutlined,
  ShoppingOutlined,
  TeamOutlined,
  ToolOutlined,
  UserOutlined,
} from "@ant-design/icons";
import React from "react";
import { ROLES } from "./permissions";

export const routes = {
  home: {
    key: "home",
    slug: "home",
    to: "/home",
    title: "Inicio",
    icon: <HomeOutlined />,
    showInMenu: true,
    showHeader: true,
    showSearch: true,
    action: null,
    role: [ROLES.admin.role, ROLES.user.role],
  },

  profile: {
    key: "profile",
    slug: "profile",
    to: "/profile",
    title: "Perfil",
    icon: <UserOutlined />,
    showInMenu: false,
    showHeader: true,
    showSearch: true,
    action: null,
    role: [ROLES.admin.role, ROLES.user.role],
  },

  users: {
    key: "users",
    slug: "users",
    to: "/users",
    title: "Usuarios",
    icon: <TeamOutlined />,
    showInMenu: true,
    showHeader: true,
    showSearch: true,
    action: null,
    role: [ROLES.admin.role],
  },

  login: {
    key: "login",
    slug: "login",
    to: "/login",
    title: "LOGIN",
    icon: <LoginOutlined />,
    showInMenu: false,
    showHeader: false,
    showSearch: false,
    action: null,
    role: [ROLES.admin.role, ROLES.user.role],
  },

  rawmaterials: {
    key: "rawmaterials",
    slug: "rawmaterials",
    to: "/rawmaterials",
    title: "Materias Primas",
    icon: <ExperimentOutlined />,
    showInMenu: true,
    showHeader: true,
    showSearch: true,
    action: null,
    role: [ROLES.admin.role],
  },
  finishedproducts: {
    key: "finishedproducts",
    slug: "finishedproducts",
    to: "/finishedproducts",
    title: "Productos Acabados",
    icon: <ContainerOutlined />,
    showInMenu: true,
    showHeader: true,
    showSearch: true,
    action: null,
    role: [ROLES.admin.role],
  },
  clientproducts: {
    key: "clientproducts",
    slug: "clientproducts",
    to: "/clientproducts",
    title: "Productos Clientes",
    icon: <ShoppingOutlined />,
    showInMenu: true,
    showHeader: true,
    showSearch: true,
    action: null,
    role: [ROLES.admin.role],
  },
  zones: {
    key: "zones",
    slug: "zones",
    to: "/zones",
    title: "Zonas",
    icon: <ApartmentOutlined />,
    showInMenu: true,
    showHeader: true,
    showSearch: true,
    action: null,
    role: [ROLES.admin.role],
  },
  machines: {
    key: "machines",
    slug: "machines",
    to: "/machines",
    title: "Máquinas",
    icon: <ToolOutlined />,
    showInMenu: true,
    showHeader: true,
    showSearch: true,
    action: null,
    role: [ROLES.admin.role],
  },
  machinevisual: {
    key: "machinevisual",
    slug: "machinevisual",
    to: "/machinevisual",
    title: "Visualizar Máquina",
    icon: <QrcodeOutlined />,
    showInMenu: false,
    showHeader: true,
    showSearch: false,
    action: null,
    role: [ROLES.admin.role],
  },
  rawmaterialvisual: {
    key: "rawmaterialvisual",
    slug: "rawmaterialvisual",
    to: "/rawmaterialvisual",
    title: "Visualizar Materia Prima",
    icon: <QrcodeOutlined />,
    showInMenu: false,
    showHeader: true,
    showSearch: false,
    action: null,
    role: [ROLES.admin.role],
  },
  finishedproductvisual: {
    key: "finishedproductvisual",
    slug: "finishedproductvisual",
    to: "/finishedproductvisual",
    title: "Visualizar Producto Acabado",
    icon: <QrcodeOutlined />,
    showInMenu: false,
    showHeader: true,
    showSearch: false,
    action: null,
    role: [ROLES.admin.role],
  },
  clientproductvisual: {
    key: "clientproductvisual",
    slug: "clientproductvisual",
    to: "/clientproductvisual",
    title: "Visualizar Producto Cliente",
    icon: <QrcodeOutlined />,
    showInMenu: false,
    showHeader: true,
    showSearch: false,
    action: null,
    role: [ROLES.admin.role],
  },
  logout: {
    key: "logout",
    slug: "logout",
    to: "/logout",
    title: "Log out",
    icon: <LogoutOutlined />,
    showInMenu: false,
    showHeader: false,
    showSearch: false,
    action: null,
    role: [ROLES.admin.role, ROLES.user.role],
  },
};
